import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/aboutCustomDataProvider';

interface ProcessedData {
  year: number;
  events: string[];
}

const AboutPart4: React.FC = () => {
  const themeColor = useSelector((state: RootState) => state.themeColor.value);
  const { customData } = useCustomData();
  const [processedData, setProcessedData] = useState<ProcessedData[]>([]);

  useEffect(() => {
    console.log(customData)
    customData.forEach(item => {
      console.log('description:', JSON.stringify(item.description));
    });

    const numericYearData = customData.filter(item => /^\d{4}$/.test(item.description));

    const yearMap: { [year: string]: string[] } = {};

    numericYearData.forEach(item => {
      const year = item.description;
      const events = item.value.split('|').map(str => str.trim()).filter(Boolean);
      if (!yearMap[year]) {
        yearMap[year] = [];
      }
      yearMap[year].push(...events);
    });

    const sortedData: ProcessedData[] = Object.entries(yearMap)
      .map(([year, events]) => ({
        year: parseInt(year, 10),
        events
      }))
      .sort((a, b) => b.year - a.year); // 年份倒序

    setProcessedData(sortedData);
  }, [customData]);

  return (
    <div className="about-part4">
      <div style={{ overflowX: 'auto', padding: '24px' }}>
        <div style={{ display: 'flex', gap: 40, minWidth: 'max-content' }}>
          {processedData.map((item) => (
            <div key={item.year} style={{ width: 320 }}>
              <h3 style={{ borderBottom: "1px solid #e5e5ee", paddingBottom: "4px", fontSize: "24px" }}>
                {item.year}
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingRight: 14 }}>
                {item.events.map((event, index) => (
                  <div
                    key={index}
                    className='about-part4-year-item'
                    style={{
                      width: 'fit-content',
                      padding: '8px 16px',
                      // color: themeColor
                    }}
                  >
                    <span style={{ marginRight: 8 }}>{(index + 1).toString().padStart(2, '0')}</span>
                    <span>{event}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutPart4;
